import { IPushNotification } from 'STORE/PushNotifications/PushNotifications.types';

export const prepareNotificationTitle = (pushNotification: IPushNotification): string => {
  return (
    (pushNotification.title || '') +
    (pushNotification.title && pushNotification.subTitle ? ': ' : '') +
    (pushNotification.subTitle || '')
  );
};
